const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (_: string, value: unknown) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return undefined;
      }
      seen.add(value);
    }
    return value;
  };
};

export default (data: unknown): string => JSON.stringify(data, getCircularReplacer());
